import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { CloseIcon, FilterIcon } from "../../../assets/images";
import { CalenderIcon } from "../../Icon";
import moment from "moment";
import { handleDate, reverseDate } from "../../../utils/commonFunctions";
import { RadioContainer } from "../../commons";
import { RadioTypes } from "../../../commonTypes/universalTypes";

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "Unscheduled",
  },
  {
    id: "2",
    name: "Re-Estimate",
  },
];

type AppProps = {
  applyFilter: (data: any) => void;
  clearFilter: () => void;
  targetStartDate: string;
  targetEndDate: string;
  filterelected: any;
  setTargetStartDate: React.Dispatch<React.SetStateAction<string>>;
  setTargetEndDate: React.Dispatch<React.SetStateAction<string>>;
  startDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  startDateTo: string;
  setStartDateTo: React.Dispatch<React.SetStateAction<string>>;
  filterStatus: string;
  setFilterStatus: React.Dispatch<React.SetStateAction<string>>;
  selectedClient: string;
  activeTab: string;
  jobType?:string
};
const UserViewListFilter = ({
  applyFilter,
  targetStartDate,
  targetEndDate,
  setTargetStartDate,
  setTargetEndDate,
  startDate,
  setStartDate,
  startDateTo,
  setStartDateTo,
  filterelected,
  filterStatus,
  setFilterStatus,
  clearFilter,
  selectedClient,
  activeTab,
  jobType
}: AppProps) => {
  const schedulingFilterRadio = true;
  const [filterTargetStartDate, setFilterTargetStartDate] = useState("");
  const [filterTargetEndDate, setFilterTargetEndDate] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterStartDateTo, setFilterStartDateTo] = useState("");
  const [toggle, setToggle] = useState(false);
  const [count, setCount] = useState(null);

  const [filterCount, setFilterCount] = useState(0);
  useEffect(() => {
    let total = filterelected?.filter((e: any) => e.length !== 0);
    setCount(total.length);
  }, [filterelected]);

  useEffect(()=>{
    setFilterTargetStartDate("");
    setFilterTargetEndDate("");
    setFilterStartDate("");
    setFilterStartDateTo("");
    setFilterCount(0);

  },[jobType])

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setFilterTargetStartDate(value);
    setTargetStartDate(value ? reverseDate(value) : "");
  };

  const handleFilterStartDateChange = (date: string) => {
    const value = handleDate(date);
    setFilterStartDate(value);
    setStartDate(value ? reverseDate(value) : "");
  };

  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setFilterTargetEndDate(value);
    setTargetEndDate(value ? reverseDate(value) : "");
  };
  const handleFilterStartDateToChange = (date: string) => {
    const value = handleDate(date);
    setFilterStartDateTo(value);
    setStartDateTo(value ? reverseDate(value) : "");
  };

  const handleRadioValue = (data: any) => {
    setFilterStatus(data);
  };
  const submitFilterData = () => {
    const finalData = {
      targetStartDate,
      targetEndDate,
      startDate,
      startDateTo,
    };
    if (targetEndDate && targetStartDate && startDate && startDateTo) {
      setFilterCount(4);
    } else if (targetEndDate || targetStartDate || startDate || startDateTo) {
      setFilterCount(1);
    } else {
      setFilterCount(0);
    }
    applyFilter(finalData);
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={FilterIcon} alt="" />
        <span className={count !== 0 ? "filter-count" : ""}>
          <span>{count !== 0 ? count : ""}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />
        <span>Filter Data For Start Date</span>
        <div className="row mt-3">
          <div className="d-flex">
            <div className="form-group col-md-6">
              <div className="date-picker-wraper mr-0 position-relative">
                <Label className="mb-1 p-0 w-100" style={{ fontSize: "14px" }}>
                  From
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      filterStartDate
                        ? new Date(
                            moment(
                              `${filterStartDate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleFilterStartDateChange(
                        moment(e).format("YYYY-MM-DD")
                      );
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="filterStartDate"
                    placeholderText="Select"
                    className="form-control"
                  />
                  <span
                    className="calender-icon pr-3"
                    style={{
                      top: "28px",
                      right: "4px",
                      cursor: "pointer",
                      position: "absolute",
                    }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <div className="date-picker-wraper mr-0">
                  <Label
                    className="mb-1 p-0 w-100"
                    style={{ fontSize: "14px" }}
                  >
                    To
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        filterStartDateTo
                          ? new Date(
                              moment(
                                `${filterStartDateTo}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        handleFilterStartDateToChange(
                          moment(e).format("YYYY-MM-DD")
                        );
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="filterStartDateTo"
                      placeholderText="Select"
                      className="form-control"
                      minDate={
                        filterStartDateTo
                          ? new Date(
                              moment(
                                `${filterStartDateTo}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                    />
                    <span
                      className="calender-icon pr-3"
                      style={{ top: "28px", right: "20px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span>Filter Data For Target End Date</span>
        <div className="row mt-3">
          <div className="d-flex">
            <div className="form-group col-md-6">
              <div className="date-picker-wraper mr-0 position-relative">
                <Label className="mb-1 p-0 w-100" style={{ fontSize: "14px" }}>
                  From
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      filterTargetStartDate
                        ? new Date(
                            moment(
                              `${filterTargetStartDate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleStartDateChange(moment(e).format("YYYY-MM-DD"));
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="filterTargetStartDate"
                    placeholderText="Select"
                    className="form-control"
                  />
                  <span
                    className="calender-icon pr-3"
                    style={{
                      top: "28px",
                      right: "4px",
                      cursor: "pointer",
                      position: "absolute",
                    }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <div className="date-picker-wraper mr-0">
                  <Label
                    className="mb-1 p-0 w-100"
                    style={{ fontSize: "14px" }}
                  >
                    To
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        filterTargetEndDate
                          ? new Date(
                              moment(
                                `${filterTargetEndDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        handleEndDateChange(moment(e).format("YYYY-MM-DD"));
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="filterTargetEndDate"
                      placeholderText="Select"
                      className="form-control"
                      minDate={
                        filterTargetStartDate
                          ? new Date(
                              moment(
                                `${filterTargetStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                    />
                    <span
                      className="calender-icon pr-3"
                      style={{ top: "28px", right: "20px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-block p-3">
          <div>
            <label style={{ fontSize: "14px" }}>Status</label>
          </div>
          <div className="mt-2">
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={handleRadioValue}
              radioValue={filterStatus}
              schedulingFilterRadio={schedulingFilterRadio}
            />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
              setFilterTargetStartDate("");
              setFilterTargetEndDate("");
              setFilterStartDate("");
              setFilterStartDateTo("");
              setFilterCount(0);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              submitFilterData();
              setToggle(!toggle);
            }}
            disabled={
              !filterTargetEndDate &&
              !filterTargetStartDate &&
              !filterStartDate &&
              !filterStartDateTo &&
              !filterStatus
            }
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default UserViewListFilter;
